import React from "react";
import { DpEmployeeStatus, EMPLOYEE_STATUS_LABELS } from "../api/dpTypes";

const MODIFIER: Record<DpEmployeeStatus, string> = {
  ATIVO: "dpBadge--green",
  AFASTADO: "dpBadge--orange",
  FERIAS: "dpBadge--blue",
  DESLIGADO: "dpBadge--red",
};

type Props = { status: DpEmployeeStatus };

const EmployeeStatusBadge: React.FC<Props> = ({ status }) => (
  <span className={`dpBadge ${MODIFIER[status] ?? "dpBadge--gray"}`}>
    {EMPLOYEE_STATUS_LABELS[status] ?? status}
  </span>
);

export default EmployeeStatusBadge;
